import { I18n } from 'i18n-js';

// Only English is compiled into the main bundle. Every other dictionary is a
// separate webpack chunk that is fetched on demand by `loadLocale` (see
// contexts/I18n/I18nContext.tsx), so a visitor only downloads the language
// they actually use instead of all ten (~4 MB of JSON).
const LOCALE_LOADERS: Record<string, () => Promise<{ default: unknown }>> = {
  vi: () => import(/* webpackChunkName: "locale-vi" */ 'redhotpie-shared-lib/i18n/vi.json'),
  es: () => import(/* webpackChunkName: "locale-es" */ 'redhotpie-shared-lib/i18n/es.json'),
  de: () => import(/* webpackChunkName: "locale-de" */ 'redhotpie-shared-lib/i18n/de.json'),
  nl: () => import(/* webpackChunkName: "locale-nl" */ 'redhotpie-shared-lib/i18n/nl.json'),
  it: () => import(/* webpackChunkName: "locale-it" */ 'redhotpie-shared-lib/i18n/it.json'),
  fr: () => import(/* webpackChunkName: "locale-fr" */ 'redhotpie-shared-lib/i18n/fr.json'),
  pt: () => import(/* webpackChunkName: "locale-pt" */ 'redhotpie-shared-lib/i18n/pt.json'),
  th: () => import(/* webpackChunkName: "locale-th" */ 'redhotpie-shared-lib/i18n/th.json'),
  id: () => import(/* webpackChunkName: "locale-id" */ 'redhotpie-shared-lib/i18n/id.json'),
};

const i18n = new I18n({
  // eslint-disable-next-line global-require
  en: require('redhotpie-shared-lib/i18n/english.json'),
});

i18n.defaultLocale = 'en';
i18n.locale = 'en';
i18n.enableFallback = true;

const loadedLocales = new Set<string>(['en']);
const pendingLocales = new Map<string, Promise<void>>();

export const isLocaleLoaded = (locale: string) => loadedLocales.has(locale);

/**
 * Fetches the dictionary for `locale` (if not already in memory) and merges
 * it into the i18n store. Resolves immediately for English or for a locale
 * that was already loaded. Unknown locales resolve without loading anything
 * so the caller falls back to English.
 */
export const loadLocale = (locale: string): Promise<void> => {
  if (loadedLocales.has(locale)) return Promise.resolve();
  const loader = LOCALE_LOADERS[locale];
  if (!loader) return Promise.resolve();

  const pending = pendingLocales.get(locale);
  if (pending) return pending;

  const promise = loader()
    .then(mod => {
      i18n.store({ [locale]: (mod.default ?? mod) as Record<string, unknown> });
      loadedLocales.add(locale);
    })
    .finally(() => {
      pendingLocales.delete(locale);
    });
  pendingLocales.set(locale, promise);
  return promise;
};

export default i18n;
